import * as CONSTANTS from '../modules/constants';
import { svgInject } from '../modules/svg-injection';
import '../modules/carousel-init';
import { AriaToggling } from '../modules/aria-toggling';
import { MobileMenu } from '../modules/mobile-menu';
import { HeaderSearch } from '../modules/header-search';
import { nodeListToArray } from '../modules/nodelist-to-array';
import { Accordions } from '../modules/accordion';
import { ScrollspyNav } from '../modules/scrollspy-nav';
import * as SmoothScroll from 'smooth-scroll';
import '../modules/youtube-hero';
import '../modules/curriculum-download';
import * as A11yDialog from 'a11y-dialog';

(function () {
    CONSTANTS.GLOBAL_HTML.classList.remove('no-js');

    new HeaderSearch(CONSTANTS.GLOBAL_BODY);
    svgInject('/Static/images/svg-sprite.svg');
    new MobileMenu(CONSTANTS.GLOBAL_BODY);
    new AriaToggling(nodeListToArray(document.querySelectorAll('#mNav .mnav-list-item > a')));

    // Accordion
    new Accordions();

    //document.addEventListener("DOMContentLoaded", () => {
    //    (window as any).initCarousel();
    //});

    new ScrollspyNav();

    var scroll = new SmoothScroll('a[href*="#"]', {
        // Selectors
        ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
        header: '#siteHeader', // Selector for fixed headers (must be a valid CSS selector)
    
        // Speed & Easing
        speed: 500, // Integer. How fast to complete the scroll in milliseconds
        offset: 100, // Integer or Function returning an integer. How far to offset the scrolling anchor location in pixels
        easing: 'easeInOutCubic', // Easing pattern to use
    
        // Callback API
        before: function (anchor, toggle) {}, // Callback to run before scroll
        after: function (anchor, toggle) {} // Callback to run after scroll
    });

    // Global Modals
    const modalsArray = nodeListToArray(document.querySelectorAll('.modal-js'));
    modalsArray.forEach(function (modal) {
        const modalInstance = new A11yDialog(modal);

        modalInstance.on('show', (dialog, e) => {
            CONSTANTS.GLOBAL_HTML.classList.add('modal-visible');
        });
        modalInstance.on('hide', (dialog, e) => {
            CONSTANTS.GLOBAL_HTML.classList.remove('modal-visible');
        })
    });
})();


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/common/global.ts